/**
 * Heathen collection facets v2 — price range slider fix
 * Key fix: clone range inputs to strip Dawn's own listeners before binding ours
 */
(function () {
  const MO_DEBOUNCE_MS = 120;

  function debounce(fn, ms) {
    let t;
    return function debounced(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), ms);
    };
  }

  function parseMoney(val, fallback) {
    if (val == null || val === '') return fallback;
    let s = String(val)
      .replace(/[()]/g, '')
      .replace(/[^\d.,\s\u00a0\u202f-]/g, '')
      .replace(/[\s\u00a0\u202f]/g, '');
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    if (lastComma > lastDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : fallback;
  }

  function resolveAbsMax(sliderRoot, maxInput) {
    const raw = parseFloat(sliderRoot.getAttribute('data-range-max-raw'));
    const displayAttr = sliderRoot.getAttribute('data-range-max-display');
    const fromDisplay = parseMoney(displayAttr || maxInput.placeholder, NaN);
    if (Number.isFinite(fromDisplay) && fromDisplay > 0) return fromDisplay;
    if (Number.isFinite(raw) && raw > 0) return raw;
    return parseMoney(maxInput.getAttribute('data-max'), NaN);
  }

  function facetSearchScope(input) {
    const fieldset = input.closest('fieldset.parent-wrap');
    if (fieldset) {
      const list = fieldset.querySelector(':scope > ul.facets-layout-list');
      if (list) return { list, itemSelector: ':scope > li.facets__item' };
    }
    const submenu = input.closest('.mobile-facets__submenu');
    if (submenu) {
      const list = submenu.querySelector(':scope > ul.mobile-facets__list');
      if (list) return { list, itemSelector: ':scope > li.mobile-facets__item' };
    }
    return null;
  }

  function bindFacetSearch(input) {
    if (input.dataset.heathenSearchBound === '1') return;
    input.dataset.heathenSearchBound = '1';
    // Dawn facet form listens for any input event and re-renders the whole section.
    // Keep facet search local-only (Magento behavior): filter options in place.
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') event.preventDefault();
      event.stopPropagation();
    });
    input.addEventListener('keyup', (event) => {
      event.stopPropagation();
    });
    input.addEventListener('change', (event) => {
      event.stopPropagation();
    });
    input.addEventListener('search', (event) => {
      event.stopPropagation();
    });
    input.addEventListener('input', (event) => {
      event.stopPropagation();
      const scope = facetSearchScope(input);
      if (!scope) return;
      const term = input.value.trim().toLowerCase();
      const items = scope.list.querySelectorAll(scope.itemSelector);
      if (!term) {
        const parentDisplay = scope.list.closest('.parent-display');
        const showMore = parentDisplay?.querySelector('show-more-button');
        const labelLess = showMore?.querySelector('.label-show-less');
        const showMoreExpanded = labelLess && !labelLess.classList.contains('hidden');
        items.forEach((li) => {
          li.classList.remove('heathen-filter-option-hidden', 'heathen-facet-search-match');
          if (li.hasAttribute('data-heathen-collapsed') && !showMoreExpanded) {
            li.classList.add('hidden');
          } else {
            li.classList.remove('hidden');
          }
        });
        // Keep list anchored at top after clearing search to avoid "jumped" layout.
        scope.list.scrollTop = 0;
        return;
      }
      items.forEach((li) => {
        const lab = li.querySelector('.facet-checkbox__text-label');
        const value = (lab?.textContent || '').trim().toLowerCase();
        const show = !value || value.includes(term);
        li.classList.remove('heathen-facet-search-match');
        if (show) {
          li.classList.remove('heathen-filter-option-hidden', 'hidden');
          li.classList.add('heathen-facet-search-match');
        } else {
          li.classList.add('heathen-filter-option-hidden');
        }
      });
      // Reset list scroll so filtered results render from the top (desktop + mobile).
      scope.list.scrollTop = 0;
    });
  }

  function initFacetSearch(root) {
    root.querySelectorAll('[data-heathen-facet-search]').forEach(bindFacetSearch);
  }

  function normalizePriceFieldInput(input) {
    if (!input || input.type !== 'text') return;
    const raw = String(input.value || '').trim();
    if (!raw) return;
    const n = parseMoney(raw, NaN);
    if (Number.isFinite(n)) input.value = String(Math.round(n));
  }

  function applyPriceRangeAbsCeiling(priceRangeEl) {
    const absR = parseFloat(priceRangeEl.getAttribute('data-heathen-range-max'));
    const maxField = priceRangeEl.querySelectorAll('input.field__input')[1];
    if (maxField && Number.isFinite(absR) && absR > 0) {
      maxField.setAttribute('data-max', String(Math.round(absR)));
    }
  }

  function patchPriceRangePrototype() {
    const Ctor = customElements.get('price-range');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__heathenPriceRangePatched) return;
    const origAdjust = Ctor.prototype.adjustToValidValues;
    const origSetMin = Ctor.prototype.setMinAndMaxValues;
    Ctor.prototype.adjustToValidValues = function (input) {
      normalizePriceFieldInput(input);
      applyPriceRangeAbsCeiling(this);
      return origAdjust.call(this, input);
    };
    Ctor.prototype.setMinAndMaxValues = function () {
      // Do NOT run if a slider drag is in progress
      if (document.querySelector('[data-heathen-price-slider][data-dragging="1"]')) return;
      this.querySelectorAll('input.field__input').forEach(normalizePriceFieldInput);
      applyPriceRangeAbsCeiling(this);
      return origSetMin.call(this);
    };
    Ctor.prototype.__heathenPriceRangePatched = true;
  }

  function normalizeAllPriceFacetInputs(root) {
    root.querySelectorAll('price-range.facets__price input.field__input').forEach(normalizePriceFieldInput);
  }

  function bindPriceFacetInputGuards(root) {
    root.querySelectorAll('price-range.facets__price input.field__input').forEach((inp) => {
      if (inp.dataset.heathenPriceInputGuard === '1') return;
      inp.dataset.heathenPriceInputGuard = '1';
      inp.addEventListener('input', (e) => {
        if (e.isTrusted) e.stopPropagation();
      }, true);
    });
  }

  function bindPriceSlider(sliderRoot) {
    if (sliderRoot.dataset.heathenBound === '1') return;

    const priceRange = sliderRoot.closest('price-range');
    if (!priceRange || !priceRange.classList.contains('facets__price')) return;

    const inputs = priceRange.querySelectorAll('input.field__input');
    if (inputs.length < 2) return;

    const minInput = inputs[0];
    const maxInput = inputs[1];

    // ── KEY FIX: Clone the range inputs to strip Dawn's listeners ──
    const origMinR = sliderRoot.querySelector('[data-heathen-range-min]');
    const origMaxR = sliderRoot.querySelector('[data-heathen-range-max]');
    if (!origMinR || !origMaxR) return;

    const minR = origMinR.cloneNode(true);
    const maxR = origMaxR.cloneNode(true);
    origMinR.parentNode.replaceChild(minR, origMinR);
    origMaxR.parentNode.replaceChild(maxR, origMaxR);

    let absMax = resolveAbsMax(sliderRoot, maxInput);
    if (!Number.isFinite(absMax) || absMax <= 0) return;

    const absMinParsed = parseMoney(minInput.getAttribute('data-min') || minInput.placeholder, NaN);
    const absMin = Number.isFinite(absMinParsed) ? absMinParsed : 0;
    const step = Math.max(1, Math.round(absMax / 100));

    minInput.setAttribute('data-max', String(absMax));
    maxInput.setAttribute('data-max', String(absMax));
    minR.min = '0';
    minR.max = String(Math.round(absMax));
    minR.step = String(step);
    maxR.min = '0';
    maxR.max = String(Math.round(absMax));
    maxR.step = String(step);

    sliderRoot.dataset.heathenBound = '1';

    function snapToStep(v) {
      return Math.min(absMax, Math.max(0, Math.round(Number(v) / step) * step));
    }

    // Mirror slider positions → text inputs (visual only, no events)
    function mirrorTextFromSliders() {
      let lo = snapToStep(parseFloat(minR.value) || 0);
      let hi = snapToStep(parseFloat(maxR.value) || absMax);

      if (lo > hi) {
        if (document.activeElement === minR) {
          lo = hi;
          minR.value = String(lo);
        } else {
          hi = lo;
          maxR.value = String(hi);
        }
      }

      minInput.value = String(lo);
      maxInput.value = String(hi);
    }

    // Sync slider handles from text input values (only when not dragging)
    function syncSlidersFromText() {
      if (sliderRoot.dataset.dragging === '1') return;

      let lo = parseMoney(minInput.value, absMin);
      let hi = parseMoney(maxInput.value, absMax);

      if (minInput.value.trim() === '') lo = absMin;
      if (maxInput.value.trim() === '') hi = absMax;
      if (absMax > absMin && lo <= absMin && hi <= absMin) hi = absMax;

      lo = Math.max(0, Math.min(lo, absMax));
      hi = Math.max(0, Math.min(hi, absMax));
      if (lo > hi) { const t = lo; lo = hi; hi = t; }

      minR.value = String(snapToStep(lo));
      maxR.value = String(snapToStep(hi));
    }

    // Submit values to Dawn's FacetFiltersForm
    function commitToForm() {
      const lo = parseMoney(minInput.value, absMin);
      const hi = parseMoney(maxInput.value, absMax);
      if (absMax > absMin && lo <= absMin && hi <= absMin) {
        maxInput.value = String(absMax);
        maxR.value = String(absMax);
      }
      normalizePriceFieldInput(minInput);
      normalizePriceFieldInput(maxInput);
      minInput.dispatchEvent(new Event('input', { bubbles: true }));
      maxInput.dispatchEvent(new Event('input', { bubbles: true }));
      minInput.dispatchEvent(new Event('change', { bubbles: true }));
      maxInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Dragging: mirror text, block Dawn from resetting
    function onRangeInput(ev) {
      ev.stopImmediatePropagation();
      ev.stopPropagation();
      sliderRoot.dataset.dragging = '1';
      mirrorTextFromSliders();
    }

    // Drag end: commit to form
    function onDragEnd() {
      if (sliderRoot.dataset.dragging !== '1') return;
      sliderRoot.dataset.dragging = '0';
      mirrorTextFromSliders();
      commitToForm();
    }

    minR.addEventListener('input', onRangeInput);
    maxR.addEventListener('input', onRangeInput);
    minR.addEventListener('change', onDragEnd);
    maxR.addEventListener('change', onDragEnd);
    minR.addEventListener('mouseup', onDragEnd);
    maxR.addEventListener('mouseup', onDragEnd);
    minR.addEventListener('touchend', onDragEnd);
    maxR.addEventListener('touchend', onDragEnd);
    minR.addEventListener('keyup', onDragEnd);
    maxR.addEventListener('keyup', onDragEnd);

    // Text input manual change
    minInput.addEventListener('change', () => {
      syncSlidersFromText();
      mirrorTextFromSliders();
    });
    maxInput.addEventListener('change', () => {
      syncSlidersFromText();
      mirrorTextFromSliders();
    });

    // Initial sync on load
    syncSlidersFromText();
    mirrorTextFromSliders();

    // Heal stale 0-0 URL state
    if (absMax > absMin) {
      const lo = parseMoney(minInput.value, absMin);
      const hi = parseMoney(maxInput.value, absMax);
      if (lo <= absMin && hi <= absMin) {
        maxR.value = String(absMax);
        maxInput.value = String(absMax);
      }
    }
  }

  function initPriceSliders(root) {
    root.querySelectorAll('[data-heathen-price-slider]').forEach(bindPriceSlider);
  }

  const HEATHEN_DISALLOWED_SORT = new Set(['relevance', 'best-selling', 'most-relevant', 'most_relevant']);

  function stripHiddenSortOptions(root) {
    const scope = root || document;
    scope
      .querySelectorAll(
        'select[name="sort_by"], select[data-heathen-sort], select[data-heathen-search-sort], select.facet-filters__sort'
      )
      .forEach((sel) => {
        if (sel.hasAttribute('data-heathen-per-page') || sel.id === 'HeathenPerPage') return;
        let removed = false;
        Array.from(sel.querySelectorAll('option')).forEach((opt) => {
          const v = (opt.value || '').toLowerCase().trim();
          if (HEATHEN_DISALLOWED_SORT.has(v)) {
            opt.remove();
            removed = true;
          }
        });
        if (removed && sel.options.length) {
          const hasSelected = Array.from(sel.options).some((o) => o.selected);
          if (!hasSelected) sel.options[0].selected = true;
        }
      });
  }

  function initHeathenFacets() {
    patchPriceRangePrototype();
    normalizeAllPriceFacetInputs(document);
    bindPriceFacetInputGuards(document);
    initFacetSearch(document);
    document.querySelectorAll('price-range.facets__price').forEach((el) => {
      if (typeof el.setMinAndMaxValues === 'function') el.setMinAndMaxValues();
    });
    initPriceSliders(document);
    stripHiddenSortOptions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeathenFacets);
  } else {
    initHeathenFacets();
  }

  const observeForm = debounce(initHeathenFacets, MO_DEBOUNCE_MS);
  ['FacetFiltersForm', 'FacetFiltersFormMobile'].forEach((id) => {
    const el = document.getElementById(id);
    if (el && typeof MutationObserver !== 'undefined') {
      new MutationObserver(observeForm).observe(el, { childList: true, subtree: true });
    }
  });

  const stripSortDebounced = debounce(() => stripHiddenSortOptions(document), 40);
  const productGrid = document.getElementById('ProductGridContainer');
  if (productGrid && typeof MutationObserver !== 'undefined') {
    new MutationObserver(stripSortDebounced).observe(productGrid, { childList: true, subtree: true });
  }
})();